import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  removeUpdatingNoteAdded,
  updateNoteSelected,
} from "../../actions/proposal";
import { closeModal } from "../../actions/ui";
import "./ProposalNoteSelectedEditing.scss";

const ProposalNoteSelectedEditing = () => {
  const noteToUpdate = useSelector((state) => state.proposals.noteToUpdate);
  const { description } = noteToUpdate;
  const initialValues = {
    description: description,
  };
  const NoteSchema = Yup.object().shape({
    description: Yup.string().required("Note Required to update"),
  });

  const dispatch = useDispatch();
  const handleFormikSubmit = (values) => {
    dispatch(updateNoteSelected(values));
    dispatch(removeUpdatingNoteAdded());
    dispatch(closeModal());
  };
  return (
    <div className="note-write-form__container">
      <div className="form-note-area__wrapper">
        <div className="note__heading">
          <h2 className="title-gray-bold-22">Update a note to the proposal.</h2>
        </div>

        <div className="note-form-content">
          <Formik
            initialValues={initialValues}
            onSubmit={handleFormikSubmit}
            validationSchema={NoteSchema}
            enableReinitialize
          >
            <Form>
              <div className="note__content">
                <Field
                  className="note__content-textarea"
                  as="textarea"
                  name="description"
                  placeholder="Description..."
                />
              </div>

              <div className="error-message-form">
                <ErrorMessage name="description" />
              </div>

              <div className="note__button-area">
                <button className="btn-primary" type="submit">
                  Update
                </button>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ProposalNoteSelectedEditing;
